<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    // 保留登录态，除非手动退出
    // 登录拦截
    this.$router.beforeEach((to, from, next) => {
      const isLogin = this.$store.state.isLogin
      const role = this.$store.state.userRole
      if (to.path !== '/login' && !isLogin) {
        console.log("🚀 ~ beforeEach ~ to:", to)
        next('/login')
      } else if (to.path === '/login' && isLogin) {
        console.log("🚀 ~ beforeEach ~ next:", to)
        next('/')
      } else if (isLogin && role === 'subadmin') {
        const allowed = ['/order', '/user', '/face-recognition', '/']
        if (!allowed.includes(to.path)) {
          next('/order')
        } else {
          next()
        }
      } else if (isLogin && role === 'super') {
        const allowed = ['/account', '/']
        if (!allowed.includes(to.path)) {
          next('/account')
        } else {
          next()
        }
      } else {
        next()
      }
    })
  }
}
</script>

<style>
html, body, #app,
.el-header, .header-bar, .el-main, .el-container, .main-container, .el-aside, .el-content, .el-root {
  border: none !important;
  border-top: none !important;
  border-bottom: none !important;
  box-shadow: none !important;
  background-image: none !important;
}
.el-header, .header-bar {
  border-bottom: none !important;
  box-shadow: none !important;
}
.el-main, .main-container {
  border-top: none !important;
  box-shadow: none !important;
}
html, body, #app {
  height: 100vh !important;
  overflow: hidden !important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
}
</style>
